// adsenseManager.ts
"use client";

// Objeto global para seguimiento de anuncios
declare global {
  interface Window {
    adsbygoogle: unknown[];
    adsenseInitialized: boolean;
    initializedAds: Set<string>;
  }
}

// Inicializar propiedades globales si no existen
export const initGlobals = () => {
  if (typeof window !== "undefined") {
    window.adsbygoogle = window.adsbygoogle || [];
    window.initializedAds = window.initializedAds || new Set();
    window.adsenseInitialized = window.adsenseInitialized || false;
  }
};

// Inicializar anuncios específicos por ID
export const initializeAd = (id: string) => {
  initGlobals();

  if (typeof window === "undefined" || !window.adsbygoogle) return;

  // Si este anuncio específico ya fue inicializado, no hacer nada
  if (window.initializedAds.has(id)) return;

  try {
    window.adsbygoogle.push({});
    window.initializedAds.add(id);
  } catch (error) {
    console.error(`Error al inicializar anuncio ${id}:`, error);
  }
};

// Limpiar el seguimiento para un anuncio específico
export const cleanupAd = (id: string) => {
  if (typeof window !== "undefined" && window.initializedAds) {
    window.initializedAds.delete(id);
  }
};
